import { FC } from 'react'
import { Grid, InputAdornment, TextField } from '@mui/material'
import { FormikProps } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { StyledCard, StyledCardContent, StyledCardHeader } from './styledComponents'

interface Props {
  formik: FormikProps<any>
  order: any
  isCustomer: boolean | string | undefined
  permission: (field: string) => boolean
}

const BudgetSection: FC<Props> = ({ formik, order, isCustomer, permission }) => {
  const intl = useIntl()

  return (
    <StyledCard>
      <StyledCardHeader title={<FormattedMessage id="budgets" />} />
      <StyledCardContent>
        <Grid container spacing={3}>
          {permission('budget') && !isCustomer && (
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'budget' })}
                id="budget"
                name="budget"
                placeholder="budget"
                type="number"
                onChange={formik.handleChange}
                error={formik.touched.budget && Boolean(formik.errors.budget)}
                value={formik.values.budget}
              />
            </Grid>
          )}
          {permission('price') && (
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={<FormattedMessage id="price" />}
                id="price"
                name="price"
                placeholder="Price"
                type="number"
                onChange={formik.handleChange}
                error={formik.touched.price && Boolean(formik.errors.price)}
                value={formik.values.price}
              />
            </Grid>
          )}
          {permission('runtime') && (
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={<FormattedMessage id="runtime" />}
                id="runtime"
                name="runtime"
                placeholder="Runtime"
                type="number"
                onChange={formik.handleChange}
                error={formik.touched.runtime && Boolean(formik.errors.runtime)}
                value={order?.runtime}
                InputProps={{
                  endAdornment: <InputAdornment position="start">days</InputAdornment>,
                }}
              />
            </Grid>
          )}
        </Grid>
      </StyledCardContent>
    </StyledCard>
  )
}

export default BudgetSection
